module.exports = __webpack_public_path__ + "img/disconnected.096f6fb8.png";